import React from 'react'
import { Box, Typography } from '@material-ui/core'
import SingleDatePickerField from 'Event/components/date-picker-single-field'
import {
  parseDateFilterBetweenOperand,
  parseDateFilterStorageValue,
  toDateFilterStorageValue,
} from 'core/table/dateFilterUtils'
import { operatorTypes } from 'core/table/interfaces/Filters'

type FilterModalDateValueProps = {
  operator: string
  operand: unknown
  disabled: boolean
  onChange: (operand: unknown) => void
  valueFieldClassName: string
}

const FilterModalDateValue = ({
  operator,
  operand,
  disabled,
  onChange,
  valueFieldClassName,
}: FilterModalDateValueProps) => {
  if (operator === operatorTypes.IS_KNOWN || operator === operatorTypes.IS_UNKNOWN) {
    return null
  }

  if (operator === operatorTypes.IS_BETWEEN) {
    const { from, to } = parseDateFilterBetweenOperand(operand)
    return (
      <Box className={valueFieldClassName}>
        <SingleDatePickerField
          label=""
          inputVariant="filter"
          placeholder="MM/DD/YYYY"
          disabled={disabled}
          value={parseDateFilterStorageValue(from)}
          onChange={date =>
            onChange({
              ...parseDateFilterBetweenOperand(operand),
              from: toDateFilterStorageValue(date),
            })
          }
        />
        <Typography align="center" color="primary" style={{ fontSize: 14, margin: '4px 0' }}>
          to
        </Typography>
        <SingleDatePickerField
          label=""
          inputVariant="filter"
          placeholder="MM/DD/YYYY"
          disabled={disabled}
          value={parseDateFilterStorageValue(to)}
          onChange={date =>
            onChange({
              ...parseDateFilterBetweenOperand(operand),
              to: toDateFilterStorageValue(date),
            })
          }
        />
      </Box>
    )
  }

  return (
    <Box className={valueFieldClassName}>
      <SingleDatePickerField
        label=""
        inputVariant="filter"
        placeholder="MM/DD/YYYY"
        disabled={disabled}
        value={parseDateFilterStorageValue(operand)}
        onChange={date => onChange(toDateFilterStorageValue(date))}
      />
    </Box>
  )
}

export default FilterModalDateValue
